export default __webpack_public_path__ + "static/media/harvester.d60671b6.svg";